import React from 'react';
import { ReviewCard, LoadingSkeleton } from './reviews/ReviewCard.jsx';
import { getDocumentLocale } from './reviews/reviewHelpers.js';
import { useReviews } from './reviews/useReviews.js';

const FALLBACK_REVIEWS = [
  {
    author_name: 'Richard Dekkers',
    rating: 5,
    text: 'Excellent service, professional driver, and comfortable ride. Highly recommended for airport transfers.',
    time: '2025-01-15',
  },
  {
    author_name: 'Sarah Johnson',
    rating: 4,
    text: 'Very punctual and professional. Clean vehicle and friendly driver. Will definitely book again.',
    time: '2025-01-08',
  },
  {
    author_name: 'Mike Chen',
    rating: 5,
    text: 'Outstanding service from booking to drop-off. Driver was early and helped with luggage. Perfect!',
    time: '2025-01-02',
  },
];

const Section = ({ children }) => (
  <section
    className="lg:bg-white max-w-full pt-10 lg:p-10 mx-auto lg:py-12 border-outer-light-blue lg:border-outer-white"
    style={{ marginTop: '-40px' }}
  >
    <div className="mx-auto max-w-(--design-max-width) px-4">{children}</div>
  </section>
);

const Reviews = ({
  apiEndpoint = '/api/reviews',
  limit = 6,
  locale = getDocumentLocale(),
}) => {
  const { reviews, loading, error } = useReviews(apiEndpoint, FALLBACK_REVIEWS);

  if (loading) {
    return (
      <Section>
        <div className="text-center mb-8">
          <img
            src="/assets/google-reviews.png"
            alt="Google Reviews"
            className="mx-auto mb-4"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {Array.from({ length: 6 }, (_, index) => (
            <LoadingSkeleton key={index} />
          ))}
        </div>
      </Section>
    );
  }

  if (error && reviews.length === 0) {
    return (
      <Section>
        <div className="text-center mb-8">
          <img
            src="/assets/google-reviews.png"
            alt="Google Reviews"
            className="mx-auto mb-4"
          />
          <p className="text-red-500">
            Failed to load reviews. Please try again later.
          </p>
        </div>
      </Section>
    );
  }

  return (
    <Section>
      <div className="text-center mb-8">
        <img
          src="/assets/google-reviews.png"
          alt="Google Reviews"
          className="mx-auto mb-4"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
        {reviews.slice(0, limit).map((review, index) => (
          <ReviewCard
            key={`${review.author_name}-${review.time}-${index}`}
            review={review}
            locale={locale}
          />
        ))}
      </div>
    </Section>
  );
};

export default Reviews;
